module.exports = __webpack_public_path__ + "static/media/st-sebas.03d3c8e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schools/main/st-sebas.jpg
// module id = 731
// module chunks = 0